console.log("Conversation State Loaded");

let AI_STATE = {

    active: false,

    family: null,

    step: 0,

    answers: {}

};
function startConversation(family, knownAnswers = {}){

    AI_STATE.active = true;

    AI_STATE.family = family;

    AI_STATE.step = 0;

    AI_STATE.answers = knownAnswers;

}
function stopConversation(){

    AI_STATE.active = false;

    AI_STATE.family = null;

    AI_STATE.step = 0;

    AI_STATE.answers = {};

}
function getCurrentQuestion(){

    const flow = getConversationFlow(AI_STATE.family);

    while(AI_STATE.step < flow.length){

        const question = flow[AI_STATE.step];

        if(AI_STATE.answers[question.id]){

            AI_STATE.step++;

            continue;

        }

        return question;

    }

    return "FINISHED";

}
function saveConversationAnswer(answer){

    const question = getCurrentQuestion();

    if(!question){

        return null;

    }

    AI_STATE.answers[question.id] = answer;

    AI_STATE.step++;

    const flow = getConversationFlow(AI_STATE.family);

    //--------------------------------------
    // Conversation Finished
    //--------------------------------------

    if(AI_STATE.step >= flow.length){

        return "FINISHED";

    }

    return getCurrentQuestion();

}